module.exports = __webpack_public_path__ + "img/avatar_dark.dc0d481e.svg";